import { Controller } from "@hotwired/stimulus"

// Studio section tab bar. Drives only the active-tab styling; the matching
// resume-editor#selectModule (same data-action) handles showing the module
// editor. The overflow menu toggles via a custom .rb-menu-open class (NOT the
// `hidden` utility, which app CSS marks !important).
export default class extends Controller {
  static targets = ["tab", "menu"]

  select(event) {
    const key = event.currentTarget.dataset.resumeModule
    this.tabTargets.forEach((t) => {
      t.setAttribute("data-tab-active", t.dataset.resumeModule === key ? "true" : "false")
    })
    // resume-editor#selectModule (same data-action) shows the matching editor.
  }

  toggleMenu() {
    if (this.hasMenuTarget) this.menuTarget.classList.toggle("rb-menu-open")
  }

  scrollToPreview() {
    const p = document.querySelector("#resume_preview")
    if (p) p.scrollIntoView({ behavior: "smooth", block: "start" })
  }
}
